import React from 'react';
import { twMerge } from 'tailwind-merge';
import { RadioButton } from 'phosphor-react';
import { COLORS } from '../../../../utils/colors';
import { isHTML, toInlineHTML } from '../../../../utils/helpers';

const RadioInputs = ({
  id,
  selectedOption,
  options,
  optionDescriptions,
  onChange,
  className = '',
  errorText = '',
  label = '',
  isRequired = false,
  labelTextClassName = '',
  labelSubtext = '',
}: {
  id: string;
  selectedOption: string;
  options: Array<string | { label: string; value: string }>;
  optionDescriptions?: string[];
  onChange: ({ name, value }: { name: string; value: string }) => void;
  className: string;
  errorText?: string;
  label?: string;
  isRequired?: boolean;
  labelTextClassName?: string;
  labelSubtext?: string;
}) => {
  // Most options are plain strings (label === value); supplier-branches/supplier-sales-reps
  // fields configured to save an ERP ID pass {label, value} pairs instead — see
  // resolveFieldOptions/resolveDropdownFieldOptions in conditionalOptionUtils.ts.
  const normalizedOptions = options.map((option) =>
    typeof option === 'string' ? { label: option, value: option } : option
  );

  return (
    <div>
      {(label || isRequired) && (
        <label
          htmlFor={id}
          className={twMerge('text-xs mb-1 text-left font-medium', labelTextClassName)}>
          {isRequired && <span className="text-red-500">*</span>}
          {label}
        </label>
      )}
      {labelSubtext &&
        (isHTML(labelSubtext) ? (
          <p
            className="text-2xs mb-1 text-left GREY_500-CLR"
            dangerouslySetInnerHTML={{ __html: toInlineHTML(labelSubtext) }}
          />
        ) : (
          <p className="text-2xs mb-1 text-left GREY_500-CLR">{labelSubtext}</p>
        ))}
      <div className={className}>
        {normalizedOptions.map((option, index) => (
          <div
            key={option.value}
            className="flex flex-col cursor-pointer"
            onClick={() => {
              onChange({ name: 'selectedOption', value: option.value });
            }}>
            <div className="flex items-center">
              <RadioButton
                weight={selectedOption === option.value ? 'fill' : 'thin'}
                size={20}
                color={selectedOption === option.value ? COLORS.PRIMARY_500 : COLORS.GREY_500}
              />
              <div className={twMerge('ml-1 text-xs', optionDescriptions?.[index] && 'font-bold')}>
                {option.label}
              </div>
            </div>
            {optionDescriptions?.[index] && (
              <div className="ml-6 text-xs text-gray-500">{optionDescriptions[index]}</div>
            )}
          </div>
        ))}
      </div>
      {errorText && <p className="text-2xs mt-0.5 text-red-500">{errorText}</p>}
    </div>
  );
};

export default RadioInputs;
